import { classNames } from '~/utils/styles';
import type { FormProps } from '.';

export function Form({ children, className, ...props }: FormProps) {
  return (
    <form className={classNames('flex flex-col gap-6', className)} {...props}>
      {children}
    </form>
  );
}
